function Music() {
  return (
    <div
      id="music"
      className="d-flex align-items-center justify-content-center"
    >
      <div className="container">
        <h1>
          Achei que eu nunca faria algo assim; também achei que
          nunca encontraria alguém tão especial quanto você — e te encontrei.
          As coisas mudam, ainda bem!
          <br />
          Espero que goste...
        </h1>
        <br />
        <div className="text-center">
          <iframe
            title="soundcloud-player"
            width="100%"
            height="166"
            style={{ maxWidth: "650px" }}
            scrolling="no"
            frameborder="no"
            allow="autoplay"
            src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2108999517&color=%234f4f4f&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
          ></iframe>
        </div>
      </div>
    </div>
  );
}

export default Music;
